<template>
  <div class="Headers">
    <img src="../../../assets/img/logo.jpg" alt class="img_top">
  </div>
</template>

<script>
export default {
  name: "Headers",
  data() {
    return {};
  }
};
</script>

<style lang='less'>
.Headers {
  .img_top {
    height: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/Headers/index.vue